export const MAX_NUM_PAGES = 10;
export const MAX_NUM_PAGES_MOBILE = 3;